.aha-comment-button {
  display: flex;
}

.aha-comment-button__body {
  cursor: pointer;
  align-items: center;
  color: var(--theme-link-text);
  padding-left: var(--spacer-1);
  padding-right: var(--spacer-1);
}

.aha-comment-button__body:hover {
  text-decoration: underline;
}

.aha-comment-button__line {
  color: var(--theme-tertiary-text);
}
